import { useI18nContext } from "@hopper-b2b/i18n";
import dayjs from "dayjs";
import { ActionButton } from "@hopper-b2b/ui";
import { PriceFreezeOfferCard } from "../../components/PriceFreezeOfferCard";
import { DetailsBlock } from "../../components/DetailsBlock";
import {
  Airport,
  FareDetailsV2,
  TripDetailsV2,
  TimeToLive,
} from "@b2bportal/price-freeze-api";
import { useCallback } from "react";
import "./styles.scss";
import { PassengerTypes } from "@hopper-b2b/types";
import Lock from "./lock.svg";
import { CheckoutBanner } from "../../components";

export interface IConfirmationPage {
  flightPricePerPaxText: string;
  priceFreezeOfferPricePerPaxText: string;
  priceFreezeTotalAmount: string;
  expiresOnDateTime: string;
  tripDetails: TripDetailsV2;
  fareDetails: FareDetailsV2;
  passengerMap: { [key in PassengerTypes]?: number };
  handleViewPriceFreeze: () => void;
  airports?: { [key: string]: Airport };
  priceFreezeTtl?: TimeToLive;
}

export const ConfirmationPage = (props: IConfirmationPage) => {
  const {
    flightPricePerPaxText,
    priceFreezeOfferPricePerPaxText,
    priceFreezeTotalAmount,
    expiresOnDateTime,
    tripDetails,
    fareDetails,
    passengerMap,
    handleViewPriceFreeze,
    airports,
    priceFreezeTtl,
  } = props;

  const { t } = useI18nContext();
  const onViewPriceFreezeClick = useCallback(() => {
    handleViewPriceFreeze();
  }, [handleViewPriceFreeze]);

  return (
    <div className="checkout-page">
      <CheckoutBanner
        title={t("priceFreezePurchase.confirmation.title")}
        subtitle={t("priceFreezePurchase.confirmation.subtitle")}
        icon={Lock}
      />
      <PriceFreezeOfferCard
        message={``}
        frozenFlightPrice={`${flightPricePerPaxText}/${t(
          "priceFreezePurchase.offerCard.traveler"
        )}`}
        priceFreezePrice={`${priceFreezeOfferPricePerPaxText}/${t(
          "priceFreezePurchase.offerCard.traveler"
        )}`}
        priceFreezeSecondsTtl={dayjs(expiresOnDateTime).diff(dayjs(), "s")}
        isOnConfirmation={true}
        priceFreezeTtl={priceFreezeTtl}
      />
      <DetailsBlock
        tripDetails={tripDetails}
        fareDetails={fareDetails}
        priceFreezeTotalAmount={priceFreezeTotalAmount}
        passengerMap={passengerMap}
        airports={airports}
      />
      <div className="checkout-button-container">
        <ActionButton
          onClick={onViewPriceFreezeClick}
          message={t("priceFreezePurchase.confirmation.cta")}
        />
      </div>
    </div>
  );
};
